import { render, staticRenderFns } from "./codigo.vue?vue&type=template&id=5cfb7f9b&"
import script from "./codigo.vue?vue&type=script&lang=js&"
export * from "./codigo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports